import { Checkbox as AntCheckbox } from 'antd';
import styled from 'styled-components';

export const Checkbox = styled(AntCheckbox)``;
